import { useState } from "react";
import io from "socket.io-client";
import './App.css';
import Chat from "./Chat";

//const socket=io.connect("http://localhost:3001");
const  socket=io.connect("https://react-chatappmg.herokuapp.com/");

function App() {
  const [username,setUsername]=useState("");
  const [room,setRoom]=useState("");
  const [showChat,setShowChat]=useState(false);


  const joinRoom= () =>{
   if(username!="" && room!=""){
    socket.emit("join_room",room);
    setShowChat(true);
   }
  };



  return (
    <div className="App">
      {!showChat ? (
      <div className="joinChatContainer">
      <h3>Join A Chat</h3>
      <input type="text" placeholder="John.."  onChange={(event) => {setUsername(event.target.value)}}/>
      <input type="text" placeholder="Room ID..."  onChange={(event) => {setRoom(event.target.value)}}/>
      <button onClick={joinRoom}>Join Chat</button>
      </div> )
      :(
      
      <Chat socket={socket} username={username} room={room} />)}
    </div>
  );
}

export default App;
